<!--
 * @Author: wufei
 * @Date: 2020-08-13 11:28:24
 * @LastEditTime: 2020-08-24 10:14:33
 * @Description:
 * @FilePath: \mobile-revive\src\views\report\index.vue
-->
<template>
  <div class="report-index">
    <report v-if="active === 0" />
    <iframe v-if="active === 1" width="100%" height="80%" :src="analysisUrl" frameborder="0" />
    <iframe v-if="active === 2" width="100%" height="80%" :src="url" frameborder="0" />
    <tabbar v-model="active">
      <tabbar-item v-show="menuD" icon="description">复盘报告</tabbar-item>
      <tabbar-item v-show="menuE" icon="bill-o">成交分析</tabbar-item>
      <tabbar-item v-show="menuF" icon="notes-o">上会报告</tabbar-item>
    </tabbar>
  </div>
</template>

<script>
import { setTitle } from '@/api/dd'
import { Tabbar, TabbarItem, Notify } from 'vant'
import report from './reviveReport'
import store from '@/store/index'
export default {
    name: 'ReportIndex',
    components: {
        Tabbar,
        TabbarItem,
        report
    },
    data() {
        return {
            landId: this.$route.query['landId'],
            plateId: this.$route.query['plateId'],
            versionId: this.$route.query['versionId'],
            active: 0,
            token: sessionStorage.getItem('ddToken'),
            url: '',
            analysisUrl: '',
            menuD: true, // 复盘报告权限
            menuE: true, // 成交分析权限
            menuF: true // 上会报告权限
        }
    },
    watch: {
        active(n, o) {
            if (n === 1) {
                this.analysisUrl = `${process.env.VUE_APP_MOBILE}transactionAnalysis?id=${this.landId}-111&appToken=${this.token}`
            }
            if (n === 2) {
                if (!this.versionId) {
                    this.active = o
                    Notify({ type: 'warning', message: '地区未提交方案' })
                }
                this.url = `${process.env.VUE_APP_MOBILE}upperConferenceReport?versionId=${this.versionId}&plateId=${this.plateId}&landId=${this.landId}&approvalToggle=false&pageRustle=gzt&appToken=${this.token}`
            }
        }
    },
    created() {
        setTitle('复盘报告')
        this.active = 0
        const menuList = JSON.parse(sessionStorage.getItem('userDetail')).currentMenuList || []
        const d = menuList.find(item => item.permissionCode === 'm:reviveChart:D')
        const e = menuList.find(item => item.permissionCode === 'm:reviveChart:E')
        const f = menuList.find(item => item.permissionCode === 'm:reviveChart:F')
        this.menuD = !!d
        this.menuE = !!e
        this.menuF = !!f
        this.active = this.menuD ? 0 : '' || this.menuE ? 1 : '' || this.menuF ? 2 : ''
        if (this.active === '') {
            Notify({ type: 'danger', message: '暂无权限!' })
        }
        // console.log('env', process.env.VUE_APP_MOBILE)
    },
    mounted() {

    }
}
</script>

<style lang="scss" scoped>
  .report-index {
    width:100%;
    height:100%;
    iframe {
      width:100%;
      height:90%;
    }
  }
</style>

<style lang="scss">
  .report-index {
    .van-tabbar-item {
      font-size:.2rem /* 20/100 */;
    }

    .van-tabbar-item__icon {
      font-size:.4rem /* 40/100 */;
    }

    .van-tabbar {
      height:1rem /* 100/100 */;
    }
  }
</style>
